//主页面
const index = () => import(/* webpackChunkName:'grounp' */ '@/components/home.vue');

//原料入库明细详情
const materialsInStock = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/productionCenter/materialsInStock/list.vue');

const productionRouter = {
  path: '/production',
  component: index,
  children: [
    {
      path: 'materialsInStock',
      name: 'materialsInStock',
      component: materialsInStock,
      meta: {
        keepAlive: true,
        title: '原料入库明细',
      },
    },
    // {
    //   path: 'rawDataAdd',
    //   name: 'rawDataAdd',
    //   component: rawDataAdd,
    //   meta: {
    //     keepAlive: true,
    //     title: '成品出库新增'
    //   }
    // }
  ],
};
export default productionRouter;
